module.exports = __webpack_public_path__ + "img/join.dd01ccee.png";